import classNames from 'classnames';
import { debounce } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Theme from 'styles/theme';

class HoverCard extends Component {
  static propTypes = {
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    top: PropTypes.number,
    right: PropTypes.number,
    bottom: PropTypes.number,
    left: PropTypes.number,
    className: PropTypes.string,
  };

  static defaultProps = {
    onMouseEnter: () => {},
    onMouseLeave: () => {},
    onFocus: () => {},
    onBlur: () => {},
    children: null,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    className: '',
  };

  handleMouseEnter = debounce(() => {
    this.setState({ isActive: true });
    this.props.onMouseEnter();
  });

  handleMouseLeave = debounce(() => {
    this.setState({ isActive: false });
    this.props.onMouseLeave();
  });

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }

  handleFocus = () => {
    this.setState({ isActive: true });
    this.props.onFocus();
  };

  handleBlur = e => {
    const parentComponent = e.currentTarget;
    setTimeout(() => {
      if (!parentComponent.contains(document.activeElement)) {
        this.setState({ isActive: false });
        this.props.onBlur();
      }
    });
  };

  render() {
    const { isActive } = this.state;
    const { top, right, left, bottom, className, ...otherProps } = this.props;
    return (
      <div
        {...otherProps}
        role="button"
        tabIndex={0}
        className={classNames('HoverCard', className, {
          'HoverCard--active': isActive,
        })}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className="HoverCard__children">{this.props.children}</div>
        <style jsx>
          {`
            .HoverCard {
              position: relative;
              display: block;
              outline: none;
            }

            .HoverCard.HoverCard--active {
              z-index: 52;
            }

            .HoverCard::before {
              content: '';
              position: absolute;
              background-color: ${Theme.get('colors-white')};
            }

            .HoverCard.HoverCard--active::before {
              top: -${top}px;
              right: -${right}px;
              bottom: -${bottom}px;
              left: -${left}px;
              box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.23);
            }
          `}
        </style>
      </div>
    );
  }
}

export default HoverCard;
